import { Typography } from '@mui/material';
import { CenterBox } from './center-box';
import { MovieceptionPrimaryButton } from '../components/Buttons/movieception-buttons';
import { useAuth } from '../context/AuthContext';

interface NotLoggedInProps {
    message: string;
}

export const NotLoggedIn: React.FC<NotLoggedInProps> = ({ message }) => {
    const { loginWithPopup } = useAuth();

    return (
        <CenterBox>
            <Typography variant="h5">
                You're not logged in
            </Typography>
            <Typography variant="body1" color="text.secondary">
                {message}
            </Typography>
            <MovieceptionPrimaryButton
                label="Log In"
                onClick={() => loginWithPopup()}
            />
        </CenterBox>
    );
};
